export default __webpack_public_path__ + "static/media/arrow-right-gradient.596a4ff0.svg";